export default __webpack_public_path__ + "static/media/Netflix4.23b06923.PNG";